import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { RutService } from 'src/app/shared/services/rut.service';
import * as _ from 'lodash';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ProductosFormAddEditComponent } from '../form-add-edit/form-add-edit.component';
import { producto } from 'src/app/shared/object/producto.model';

@Component({
  selector: 'app-productos-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService],
})
export class ProductoModalAddEditComponent implements OnInit {
  private client: GraphQLClient = null;

  // Output
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // Modales
  @ViewChild('addEditProducto', { static: true }) addEditProductoModal: ModalDirective;
  @ViewChild(ProductosFormAddEditComponent, { static: true }) addEditProductoComponent: ProductosFormAddEditComponent;

  mode: 'ADD' | 'EDIT';
  rut_empresa: number;
  sucursal_codigo: number;
  codgo_modulo: number = 2;
  rut_usuario: number;

  // Utils
  private log: any;

  constructor(client: GraphQLClient, private accesolocalstorage: SecurityService, private toastService: ToastService, private rutService: RutService, private clog: ConsoleService) {
    this.client = client;
    this.log = this.clog.log('PRODUCTOS MODAL ADD/EDIT');
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = Number(this.accesolocalstorage.getRutUsuario());
  }

  showNew() {
    this.mode = 'ADD';
    this.addEditProductoComponent.showNew();
    this.addEditProductoModal.show();
  }

  showEdit(pro: producto) {
    this.mode = 'EDIT';
    this.addEditProductoComponent.showEdit(pro);
    this.addEditProductoModal.show();
  }

  guardar() {
    const isValid = this.addEditProductoComponent.validate();
    if (!isValid) {
      this.toastService.warning('Complete el formulario');
      return;
    }

    this.addEditProductoComponent.guardar();
  }

  onSuccessSaveOrEdit() {
    this.addEditProductoModal.hide();
    this.onSuccess.emit();
  }
}
